type HapticType = "light" | "medium" | "heavy" | "success" | "error";

const HAPTIC_PATTERNS: Record<HapticType, number | number[]> = {
	light: 10,
	medium: 20,
	heavy: 35,
	success: [12, 25, 12],
	error: [28, 40, 28],
};

let lastTriggerAt = 0;

function canTriggerHaptic() {
	if (typeof window === "undefined" || typeof navigator === "undefined") {
		return false;
	}

	if (!("vibrate" in navigator)) {
		return false;
	}

	return window.matchMedia("(pointer: coarse)").matches;
}

export function triggerHaptic(type: HapticType = "light") {
	if (!canTriggerHaptic()) {
		return;
	}

	const now = Date.now();
	if (now - lastTriggerAt < 90) {
		return;
	}

	lastTriggerAt = now;
	navigator.vibrate(HAPTIC_PATTERNS[type]);
}
